import { collection, update, set, add, subcollection, all } from 'typesaurus';
import { user, timelines } from '../store';
const users = collection('users');
const timelinesCollection = subcollection('timelines', users);
// fill in state based on the logged in user
user.subscribe((value) => {
    if (value) {
        refreshTimelines(value.id);
    }
    else {
        timelines.set([]);
    }
});
// make sure the user has a doc in the datastore
user.subscribe((value) => {
    if (value) {
        createUser(value.id);
    }
});
export async function refreshTimelines(userId) {
    const usersTimelines = timelinesCollection(userId);
    all(usersTimelines).then(timelineDocs => timelines.set(timelineDocs));
}
export async function updateTimeline(userId, timelineDoc) {
    const usersTimelines = timelinesCollection(userId);
    update(usersTimelines, timelineDoc.ref.id, timelineDoc.data).then(_ => refreshTimelines(userId));
}
export async function addTimeline(userId, name) {
    const usersTimelines = timelinesCollection(userId);
    add(usersTimelines, { name: name, events: [] }).then(_ => refreshTimelines(userId));
}
export async function createUser(userId) {
    return set(users, userId, {});
}
